<template>
    <div>
      <div class="navigationLogo">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('../assets/logo.png')"
          transition="scale-transition"
          width="100"
        />
        
      </div>
      <v-divider></v-divider>
      <div>
        <v-list dense nav >
          <v-list-item  v-if="perms.includes(1)" href="/" active-class="orange--text text--darken-4">
            <v-list-item-icon>
              <v-icon small color="#262d47">fa fa-home</v-icon>
            </v-list-item-icon>

            <v-list-item-title>داشبورد</v-list-item-title>
          </v-list-item>

          <v-list-group v-if="perms.includes(1009) || perms.includes(2)" active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fa fa-user</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت کاربران</v-list-item-title>
            </template>
            <v-list-group
              sub-group
             v-if="perms.includes(2)"
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>کاربران مدیر</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/users"
                link
                v-if="perms.includes(2)"
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست کاربران</v-list-item-title>
              </v-list-item>
              
            </v-list-group>

            <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مشتریان</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
             
                href="/manage/customers/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>دسته بندی مشتریان</v-list-item-title>
              </v-list-item>
              <v-list-item
             
                href="/manage/customers"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست مشتریان</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-newspaper</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت محتوا</v-list-item-title>
            </template>
            <v-list-item
                href="/manage/content/addresses"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت آدرس ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/departments"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت دپارتمان ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/profits"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1052)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت   مزیت ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/certificate/list"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت   گواهینامه ها </v-list-item-title>
              </v-list-item>
              
              <v-list-item
                href="/manage/content/shop_profits"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
               
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت   مزیت فروشگاه</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/basesetting/headernotify"
                link
                v-if="perms.includes(1071)"
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>اطلاعیه های هدر</v-list-item-title>
              </v-list-item>
            <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت صفحات</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/content/indexseo"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                v-if="perms.includes(13)"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title> صفحه اصلی</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/shopseo"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title> سئو فروشگاه </v-list-item-title>
              </v-list-item>
          
             
              

              <v-list-item
                href="/manage/content/indexsections"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(11)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>بخش های صفحه اصلی</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/shopsections"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>بخش های  فروشگاه</v-list-item-title>
              </v-list-item>

              
            

              <!-- <v-list-item
                href="/manage/content/brandlist"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1099)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست برند ها</v-list-item-title>
              </v-list-item> -->

              <v-list-item
                href="/manage/content/cataloglist"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1100)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست کاتالوگ </v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/videogallery"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1101)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>گالری ویدئو</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/userstatics"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1001)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحات پنل کاربری</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/certificates"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1001)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه گواهینامه ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/compare"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت    مقایسه  </v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/history"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1002)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  تاریخچه فعالیت</v-list-item-title>
              </v-list-item>

              <!-- <v-list-item
                href="/manage/content/privacy-policy"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1004)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  حریم خصوصی</v-list-item-title>
              </v-list-item> -->

              <!-- <v-list-item
                href="/manage/content/job-application"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1005)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  درخواست همکاری</v-list-item-title>
              </v-list-item> -->

              <v-list-item
                href="/manage/content/return-product"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1003)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه   مرجوعی کالا</v-list-item-title>
              </v-list-item>

             

              <!-- <v-list-item
                href="/manage/content/updateprice"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1061)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه بروزترین قیمت ها</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/dailyoffers"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1062)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه تخفیفات روزانه</v-list-item-title>
              </v-list-item> -->

          

             
              <v-list-item
                href="/manage/content/contactus"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(14)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه تماس با ما</v-list-item-title>
              </v-list-item>
              
             

              <v-list-item
                href="/manage/content/aboutus"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(16)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه درباره ما</v-list-item-title>
              </v-list-item>

             

              <v-list-item
                href="/manage/content/goalspolicy"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(18)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  اهداف و خط مشی</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/termsconditions"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(19)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  قوانین و مقررات</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/faq"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(20)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  سوالات متداول</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/regguid"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(21)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>صفحه  راهنمای ثبت نام</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/physicalpurchasetraining"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(22)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>   خرید محصول </v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/exportrequestpage"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
               
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>   درخواست صادرات محصول </v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/content/majorrequestpage"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
               
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>    سفارش عمده محصول </v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/productionrequestpage"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
               
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>    سفارش تولید </v-list-item-title>
              </v-list-item>


              <v-list-item
                href="/manage/content/physicalreciept"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(23)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>   دریافت محصول </v-list-item-title>
              </v-list-item>

         

              <v-list-item
                href="/manage/content/userarea"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(24)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>   راهنمای ناحیه کاربری</v-list-item-title>
              </v-list-item>

            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(25) || perms.includes(26)"
              
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت گالری تصاویر</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/content/image_gallery/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(25)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست دسته بندی ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/image_gallery/gallery"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(26)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>گالری</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(1090) || perms.includes(1100)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت کاتالوگ و بروشور</v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- <v-list-item
                href="/manage/content/catalog/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1089)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>دسته بندی</v-list-item-title>
              </v-list-item> -->

              <v-list-item
                href="/manage/content/catalog"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1100)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>کاتالوگ و بروشور</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(27)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت اسلایدر</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/content/slider"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(27)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>اسلایدر</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/shop_slider"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
               
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>اسلایدر فروشگاه</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(30) || perms.includes(31)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت گالری ویدئو</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/content/video_gallery/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(30)"
              >
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست دسته بندی ها</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/content/video_gallery/gallery"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(31)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>گالری</v-list-item-title>
              </v-list-item>
            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(1076) || perms.includes(1077)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت سوالات متداول</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/faq/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1076)"
              >
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>دسته بندی </v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/faq/answers"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1077)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>سوالات متداول</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fa fa-bullhorn</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت اطلاع رسانی</v-list-item-title>
            </template>
            <v-list-group
              sub-group
             v-if="perms.includes(32) || perms.includes(33)"
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت اخبار</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/notices/news/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(32)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست دسته بندی</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/notices/news"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(33)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>اخبار</v-list-item-title>
              </v-list-item>

            </v-list-group>

            <!-- <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت مقالات</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/notices/article/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست دسته بندی</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/notices/article"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مقالات</v-list-item-title>
              </v-list-item>
            </v-list-group> -->

            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(12)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت لایت باکس</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/content/lightbox"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(12)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لایت باکس</v-list-item-title>
              </v-list-item>


            </v-list-group>
            <v-list-group
              sub-group
              active-class="orange--text text--darken-4"
              v-if="perms.includes(36) || perms.includes(38)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت فرم ها</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/communication/suggest"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(36)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فرم تماس با ما</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/communication/export"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فرم صادرات</v-list-item-title>
              </v-list-item>
              
              <v-list-item
                href="/manage/communication/major"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فرم سفارش عمده محصول</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/communication/production"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فرم درخواست تولید</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/communication/newsletter"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(38)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>خبرنامه </v-list-item-title>
              </v-list-item>

            </v-list-group>
          </v-list-group>
          <v-list-group active-class="orange--text text--darken-4"  v-if="perms.includes(4)">
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-stream</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت دسته بندی</v-list-item-title>
            </template>
            

           
              
              <v-list-item
                href="/manage/category/product/category"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(4)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>محصولات </v-list-item-title>
              </v-list-item>
             
           
          </v-list-group>
          <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-info</v-icon></v-list-item-icon>
              <v-list-item-title >اطلاعات پایه</v-list-item-title>
            </template>
            <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title> محصول</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                href="/manage/basesetting/product/label"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(7)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت برچسب ها</v-list-item-title>
              </v-list-item>
             

              

              <!-- <v-list-item
                href="/manage/basesetting/product/boxgiftwrapper"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1075)"
              >

              <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت کادوپیچ</v-list-item-title>
              </v-list-item> -->

              <!-- <v-list-item
                href="/manage/basesetting/product/warranty"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1016)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت گارانتی</v-list-item-title>
              </v-list-item> -->

              
              <v-list-item
                href="/manage/basesetting/product/attribute"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(5)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت صفت ساز</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/basesetting/product/valueattribute"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت ویژگی های قیمت</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/category/product/brands"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت برند ها</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item
                href="/manage/basesetting/product/formula"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فرمول ساز</v-list-item-title>
              </v-list-item> -->
            </v-list-group>

          </v-list-group>
          <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-boxes</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت محصول</v-list-item-title>
            </template>
           
              <v-list-item
                href="/manage/product/physical"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(8)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست محصولات </v-list-item-title>
              </v-list-item>
        
          
          </v-list-group>

          <!-- <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-boxes</v-icon></v-list-item-icon>
              <v-list-item-title >مدیریت مزایدات</v-list-item-title>
            </template>
           
              <v-list-item
                href="/manage/special/auctions"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(8)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست مزایدات </v-list-item-title>
              </v-list-item>
        
          
          </v-list-group> -->



          <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت درخواست ها</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/requests/invoices"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(28)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت سفارشات </v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/requests/tickets"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت تیکت ها </v-list-item-title>
              </v-list-item>
              
              
              <!-- v-if="perms.includes(2211)" -->
              <v-list-item
                href="/manage/requests/comments"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>مدیریت نظرات </v-list-item-title>
              </v-list-item>
            

           
              
              <v-list-item
                href="/manage/requests/availablerequest"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1082)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title> درخواست های موجودی کالا</v-list-item-title>
              </v-list-item>
              
             
              
           
            </v-list-group> 
            <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت تخفیفات</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/basesetting/product/coppon"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(9)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>لیست تخفیفات</v-list-item-title>
              </v-list-item>

              <!-- <v-list-item
                href="/manage/basesetting/product/festival"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1050)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تخفیفات جشنواره ای</v-list-item-title>
              </v-list-item> -->
            </v-list-group> 
            <v-list-group
              sub-group
              
              active-class="orange--text text--darken-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>مدیریت پروموشن</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                href="/manage/basesetting/promotions/specialsale"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1040)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>فروش ویژه</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/basesetting/promotions/imagebox"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1041)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>باکس های تصویری فروشگاه</v-list-item-title>
              </v-list-item>

              <v-list-item
                href="/manage/basesetting/promotions/moveablebox"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                v-if="perms.includes(1042)"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>باکس های متحرک</v-list-item-title>
              </v-list-item>
              <v-list-item
                href="/manage/basesetting/promotions/shopmoveablebox"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
              >
                
                <v-list-item-icon>
                  <v-icon size="8">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>باکس های متحرک فروشگاه</v-list-item-title>
              </v-list-item>

            </v-list-group>


          <v-list-group active-class="orange--text text--darken-4" >
            <template v-slot:activator>
              <v-list-item-icon ><v-icon small color="#262d47">fas fa-cogs</v-icon></v-list-item-icon>
              <v-list-item-title >تنظیمات سایت</v-list-item-title>
            </template>
           
             <v-list-item
                href="/manage/basesetting"
                link
                :ripple="{class:'orange--text text--darken-4'}"
                active-class="orange--text text--darken-4"
                
              >
                
                <v-list-item-icon>
                  <v-icon size="14">fa fa-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تنظیمات</v-list-item-title>
              </v-list-item>

          </v-list-group>
        </v-list>
      </div>
    </div>
</template>
<script>
export default {
    name:"navmenu",
    data:()=>({
     perms:[]
    }),
    beforeCreate()
    {
      // this.perms = this.$store.getters.GetUser.perms;
    },
    created()
    {
      this.perms = this.$store.getters.GetUser.perms;
      console.error("PERMISSIONS",this.perms);
    }
}
</script>